export const columnsHistoryData = [
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "BRANCH ID",
    accessor: "branch_id",
  },
  {
    Header: "BILL ID",
    accessor: "id_bill",
  },
  {
    Header: "BILL STATUS",
    accessor: "data_type",
  },
];
